const FILTER_TRIGGER = '[data-sollie-filter-target]';

function getTargetPanel(dialogRoot, target) {
  if (target === 'sort') {
    return dialogRoot.querySelector('.sorting-filter, .sorting-filter-component');
  }

  if (target === 'all') {
    return dialogRoot.querySelector('.facets__panel, .sorting-filter');
  }

  const safeTarget = window.CSS?.escape ? window.CSS.escape(target) : target;
  return dialogRoot.querySelector(`[id$="-${safeTarget}"]`);
}

function revealFilterTarget(trigger) {
  const section = trigger.closest('.shopify-section');
  const drawer = section?.querySelector('#filters-drawer') || document.querySelector('#filters-drawer');
  const dialog = drawer?.querySelector('dialog');
  const target = trigger.dataset.sollieFilterTarget;

  if (!dialog || !target) return;

  window.setTimeout(() => {
    const panel = getTargetPanel(dialog, target);
    if (!panel) return;

    const details = panel.matches('details') ? panel : panel.closest('details');
    if (details) details.open = true;

    const focusTarget = panel.querySelector('summary, select, input, button') || panel;
    panel.scrollIntoView({ block: 'start', behavior: 'smooth' });
    if (focusTarget instanceof HTMLElement) focusTarget.focus({ preventScroll: true });
  }, 120);
}

if (!window.sollieMobileFiltersReady) {
  window.sollieMobileFiltersReady = true;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(FILTER_TRIGGER);
    const priceSort = event.target.closest('[data-sollie-sort-by]');
    if (priceSort instanceof HTMLButtonElement) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', priceSort.dataset.sollieSortBy);
      window.location.assign(url.toString());
      return;
    }
    if (!(trigger instanceof HTMLButtonElement)) return;
    revealFilterTarget(trigger);
  });
}
